import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import HotWorks from "@/pages/home/components/HotWorks";
import NewsSection from "@/pages/home/components/NewsSection";
import FeaturedPlots from "@/pages/home/components/FeaturedPlots";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  return (
    <>
      <HeroCarousel />
      <CategoryEntry />
      <HotWorks />
      <NewsSection />
      <FeaturedPlots />
      <SiteIntro />
    </>
  );
}